import React, {useEffect} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setAlert, hideAlert } from '../../store/actions/alertActions';

export const HandleAlertNotiItinerary = ({
  status,
  allResults,
  error
}) => {

  const dispatch = useDispatch();

  const {t} = useTranslation();
  const showAlert = useSelector(state => state.alert.isOpen);

  useEffect(() => {
    if (showAlert) {
      dispatch(hideAlert());
    }
    if (status === 'error') {
      dispatch(setAlert(error.message, 'error', t('error.label'), 'alert'));
    } else if (status === 'success') {
      if (allResults.length > 0){
        if (allResults[0].length > 0) {
          dispatch(setAlert(t('success.route-query-success'), 'success', t('success.label'), 'status'));
        } else {
          dispatch(setAlert(t('error.no-route'), 'error',  t('error.label'), 'alert'));
        }
      } else {
        dispatch(setAlert(t('error.no-route'), 'error',  t('error.label'), 'alert'));
      }
    }
  }, [status]);
  
  return (
    <></>
  );
};
